import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { defaultClientId } from '../config/environment';
import LoadingSpinner from './LoadingSpinner';

const DefaultClientRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // If we have a default client ID, redirect to it
    if (defaultClientId) {
      navigate(`/clients/${defaultClientId}`, { replace: true });
    } else {
      // If no default client ID is configured, redirect to client list
      navigate('/clients', { replace: true });
    }
  }, [navigate]);

  // Show loading spinner while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <LoadingSpinner />
    </div>
  );
};

export default DefaultClientRedirect; 